/**
 * Development-only routes
 * These routes are tree-shaken out of production builds via import.meta.env.DEV check.
 */

import type { RouteRecordRaw } from 'vue-router'

export const devRoutes: RouteRecordRaw[] = import.meta.env.DEV ? [
  {
    path: '/dev',
    name: 'Dev',
    component: () => import('@/views/dev/DevLayout.vue'),
    meta: { title: 'Developer Tools', hideFromNav: true },
    redirect: '/dev/staff-auth',
    children: [
      {
        path: 'staff-auth',
        name: 'DevStaffAuth',
        component: () => import('@/views/dev/StaffAuthTestPage.vue'),
        meta: { title: 'Staff Auth Testing', hideFromNav: true }
      },
      {
        path: 'payment-simulator',
        name: 'DevPaymentSimulator',
        component: () => import('@/views/dev/PaymentSimulatorPage.vue'),
        meta: { title: 'Payment Simulator', hideFromNav: true }
      }
    ]
  }
] : []
